module.exports = "/packs/002-77550d229aa00295298b2aef0c6f3974.jpg";